var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-layout',{attrs:{"max":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":"","offset-md3":"","xs12":""}},[_c('v-card',[_c('v-card-text',[_c('h2',[_c('v-icon',[_vm._v("error")]),_vm._v("\n            Cтраница не найдена\n          ")],1)])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }